<template>
  <div class="cj-sticker" :class="{ selected }" @click="$emit('click', $event)">
    <div class="sticker" :class="sticker" />
  </div>
</template>

<script>
export default {
  name: 'CJSticker',

  props: {
    selected: {
      type: Boolean,
    },

    sticker: {
      type: String,
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-sticker
    margin: 0 -4px
    width: 83px
    height: 83px
    cursor: pointer
    background-position: 3px 3px
    background-image: radial-gradient(circle, \
                                      rgba(0, 0, 0, 0.6) 35%, \
                                      rgba(0, 0, 0, 0) 52%)

    > .sticker
      transition: transform 0.3s ease-out
      transform: scale(0.662650602)

    &.selected
      > .sticker
        transform: scale(1)
        tap-highlight-color: transparent
</style>
